let config = {
    hasHwid: "true"
}
// 统一id登录页和老登录页路由根据配置项true切换
const hasHwid = config.hasHwid === 'true' ? true : false;
// 登录页在litesdk环境下需要额外加载css
const isLiteSDK = window.navigator.userAgent.toLowerCase().indexOf("hwidoauthsdk_ver") === -1 ? false : true;
const sdkCss = isLiteSDK ? [require(`custom/css/login_sdk.lazy.css`)] : [];

// 配置路由与css文件的对应关系，并在切换路由时动态卸载/加载
// 注意需要动态加载的css文件需要以.lazy.css结尾
// cssMap中的每一项返回一个当前路由所需css文件列表，可用lang参数匹配语言
const cssMap = {
    [hasHwid ? 'login2' : 'login']: (lang) => [require(`custom/css/${lang}/loginpage.lazy.css`)],
    'loginVerification': (lang) => [require(`custom/css/${lang}/loginVerification.lazy.css`)],
    'fpwd': (lang) => [require(`custom/css/fpwd2.lazy.css`)],
    'fphone': (lang) => [require(`custom/css/${lang}/fphone.lazy.css`)],
    [hasHwid ? 'login' : 'hwIDLogin']: (lang) => {
        return lang === 'zh-cn' ?
            [require('custom/css/login.lazy.css'), require('custom/css/zh-cn/login_zh.lazy.css'), ...sdkCss]
            : [require('custom/css/login.lazy.css'), ...sdkCss]
    },
    'resetPwd': (lang) => [require(`custom/css/${lang}/resetPwd.lazy.css`)],
    'privacyUpdate': (lang) => [require(`custom/css/privacyUpdate.lazy.css`)],
    'welcomeLogin': (lang) => [require(`custom/css/welcomeEmail.lazy.css`)],
    'welEmailFailed': (lang) => [require(`custom/css/welcomeEmail.lazy.css`)],
    'welEmailResend': (lang) => [require(`custom/css/welcomeEmail.lazy.css`)],
    'closecookie': (lang) => [require(`custom/css/closecookie.lazy.css`)],
    'error': (lang) => [require(`custom/css/error.lazy.css`)],
    'upgrade': (lang) => [require(`custom/css/upgrade.lazy.css`)],
    'casLoginError': (lang) => [require(`custom/css/casLoginError.lazy.css`)],
    'ssologin': (lang) => [require(`custom/css/ssologin.lazy.css`)],
    'notify': (lang) => [require(`custom/css/notify.lazy.css`)],
};

function getCurrentHash() {
    const defaultHash = 'login'
    let hash = window.location.hash.slice(2);
    let questionMarkIndex = hash.indexOf('?');
    if (~questionMarkIndex) {
        hash = hash.slice(0, questionMarkIndex);
    }
    return hash ? hash : defaultHash;
}

function handleHash(hash) {
    if (hash === lastHash) {
        return ;
    }
    if (lastCssArray) {
        for(let css of lastCssArray) {
            css.default.unuse();
        }
    }

    if (cssMap[hash]) {
        const cssArray = cssMap[hash](window.language || 'zh-cn');
        lastCssArray = cssArray;
        for(let css of cssArray) {
            css.default.use();
        }
        lastHash = hash;
    }
}

let lastHash;
let lastCssArray;

handleHash(getCurrentHash());

window.addEventListener('hashchange', ()=>{
    handleHash(getCurrentHash());
});


// WEBPACK FOOTER //
// ./public/hws/cssLoader.js